import reducer from './reducers'
import { routes } from '../routes'
import * as friendpageOperations from './operations'

export { friendpageOperations }

export default {
    reducer,
    routes
};